import ConnectionForm from '~/components/ConnectionForm';

import Connected from '../Connected';

const Hubspot = ({ connector, connect }) => {
  return (
    <div>
      {connector ? (
        <Connected connector={connector}>
          <Connected.Detail
            description="Connected as"
            value={connector?.remoteMeta?.name}
          />
        </Connected>
      ) : (
        <ConnectionForm service="hubspot" auth={connect} />
      )}
    </div>
  );
};

Hubspot.propTypes = {
  connector: PropTypes.shape({
    remoteMeta: PropTypes.shape({
      email: PropTypes.string,
    }),
  }),
  connect: PropTypes.func,
};

export default Hubspot;
